import BaseService from '@/services/base.service';
import store from '../store'

const API_URL = process.env.VUE_APP_API_URL;
// const CURRENCY_CODE = process.env.VUE_APP_CURRENCY_CODE;
// const ACCOUNT_SLUG = process.env.VUE_APP_ACCOUNT_SLUG;

class MarketService extends BaseService {
    apiGetMarkets(gameSlug) {
        return this.post(API_URL + '/api/v2/game/markets', {
            account: store.state.account,
            currency: store.state.currencyCode,
            game_slug: gameSlug
        }).then((response) => {
            const status = response.data.status;
            if (status === 'success') {
                return response.data.results;
            }
            return response.data;
        }).catch(err => {
            throw err.response.data;
        })
    }
}

export default new MarketService();
